export const toggleMainWindowScroll = (): void => {
  const { style } = document.getElementById('root') || {};

  if (!style) return;

  if (style.overflow === 'hidden') {
    window.scrollBy(0, -parseInt(style.top, 10));
    style.top = 'auto';
    style.overflow = '';
    style.height = '';
  } else {
    style.top = `${-window.scrollY}px`;
    style.overflow = 'hidden';
    style.height = '100vh';
    window.scrollTo(0, 0);
  }
};
